export default ($axios) => ({
    $axios,

    async fetch() {
        return await $axios.get('/badges')
    },

    async fetchById(id) {
        return await $axios.get(`/badges/${id}`)
    },

    async remove(id) {
        return await $axios.delete(`/badges/${id}`)
    },

    async toggle(id) {
        return await $axios.get(`/badges/${id}/toggle`)
    },

    async create(form) {
        return await $axios.post('/badges', form)
    },

    async update(id, form) {
        return await $axios.put(`/badges/${id}`, form)
    },
})
